import { Input } from "antd";
import React from "react";

const CustomInput = ({ size = "large", type = "textArea", suffix = null, prefix = null, placeholder, style = {}, onChange, onClick, ...props }) => {
    return (
        <Input size={size} type={type} suffix={suffix} prefix={prefix} onChange={onChange} onClick={onClick} placeholder={placeholder} style={{ ...style, borderRadius: "8px", }} {...props} />
    );
};

export default CustomInput;
